import { Component, OnInit, Output, Input, ViewChild, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { EntityCodes } from '../../Models/EnumModels';
import { ListRequest, ShiftSetUpModel, StaffAssignmentFilter, SaveShiftResponse, ShiftSetupFilter} from '../../Models/RequestModels';
import { Staff_Search_Assigment } from '../../Models/ResponseModels';
import { UserService } from '../../Services/UserService';
import { ShiftSetUp } from '../ShiftSetUp/ShiftSetUp';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as alasql from 'alasql';
import * as _ from "lodash";
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'StaffSkillSectionMap',
    templateUrl: './StaffSkillSectionMap.html',
})

export class StaffSkillSectionMap extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @Input() SaveShiftResponse: SaveShiftResponse;
    @Input() AllStaffList: Array<any>;

    ModalRef: NgbModalRef;
    Model: any;
    FilterModel: ShiftSetupFilter;
    StaffList: Array<any>;
    ClonedStaffList: Array<any>;
    MappedStaff: Array<any>;
    RemovedStaffList: Array<any>;
    AllStaffSelected: boolean;
    StaffId: number;
    DisableModalOpenEvent: boolean = false;
    isCollapsed: boolean;
    StaffName: string;
    HasFilter: boolean = false

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, protected userService: UserService, public shiftSetUp: ShiftSetUp) {
        super(translate, toastr, route, router, masterService);

    }
    ngOnInit(): void {
        this.FilterModel = new ShiftSetupFilter();
        this.FilterModel.ClearFilters();
    }

    Open(reqModel: ShiftSetUpModel): void {
        if (this.DisableModalOpenEvent) return;
        this.FilterModel.ClearFilters();
        
        this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true, backdrop:'static' });
        this.DisableModalOpenEvent = true;
        this.isCollapsed = true;
        this.Model = reqModel;
        let sectionIds = [];
        sectionIds.push(this.Model.SectionId);
        this.Model.SectionName = this.shiftSetUp.GetSectionName(sectionIds);
        let skillIds = [];
        skillIds.push(this.Model.SkillId);
        this.Model.SkillName = this.shiftSetUp.GetSkillName(skillIds);
        this.MappedStaff = [];
        this.RemovedStaffList = [];
        if (reqModel.SkillId) {
            this.FilterModel.SkillId = reqModel.SkillId;
        }
        else
            this.FilterModel.SkillId = 0;

        if (this.shiftSetUp.SingleStaffId && this.shiftSetUp.SingleStaffId > 0) {
            this.StaffName = "";
            this.FilterModel.StaffId = this.shiftSetUp.SingleStaffId;
            this.shiftSetUp.SingleStaffId = 0;
        }
        else
            this.FilterModel.StaffId = 0;

        this.FilterModel.SectionId = 0;
        let SelectedStaffCount: number = 0;
        this.StaffList = _.cloneDeep(this.AllStaffList);
        this.StaffList = this.StaffList.map((row) => {
            if (this.Model.SectionId == 0) {
                if (this.SaveShiftResponse.SectionStaffMapping.findIndex(obj => (obj.StaffId == row.StaffId)) >= 0) {
                    row.Selected = true;
                }
                else
                    row.Selected = false;
            }

            else if (this.SaveShiftResponse.SectionStaffMapping.findIndex(obj => (obj.SectionId == this.Model.SectionId && obj.StaffId == row.StaffId)) >= 0) {
                row.Selected = true;
                SelectedStaffCount++;
            }
            else
                row.Selected = false;
            return row;

        })
        if (SelectedStaffCount == this.StaffList.length)
            this.AllStaffSelected = true;
        else
            this.AllStaffSelected = false;
        this.ClonedStaffList = this.StaffList;
        this.LoadFilterStaffData();

        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.FilterModel.Keyword = '';
            this.FilterModel.OnlySelectedStaff = false;
            this.DisableModalOpenEvent = false;
        });
    }

     checkSkillWithCategory(Skills: number[]): number[] {
        let skillsWithCategory: number[] = [];
               let categories = this.masterService.GetCallCategories(this.Model.PropertyId);
               let keyByCategories = _.keyBy(categories, 'SkillId');
               if(Skills && Skills.length){
                    Skills.forEach((skill: number) => {
                        if(keyByCategories[skill]){
                            skillsWithCategory.push(skill);
                        }
                    });
                    return skillsWithCategory;
               } else {
                return skillsWithCategory;
               }
           }

    LoadFilterStaffData() {
        let queryString = 'SELECT * FROM ? where 1=1 ';
        this.HasFilter = false;
        let searchKeyword: string;
        if (this.FilterModel.StaffMapped != "" || this.FilterModel.ServiceStatus != "" || this.FilterModel.LoginStatus != "") {
            
            queryString += this.FilterModel.StaffMapped + ' ' + this.FilterModel.ServiceStatus + ' ' + this.FilterModel.LoginStatus;
            this.HasFilter = true;
        }

        if (this.FilterModel.Keyword.trim() != "") {
            searchKeyword = '%' + this.FilterModel.Keyword.trim().toLocaleUpperCase() + '%';
            queryString += ' and UCASE(Description) like ? or UCASE(SkillName) like ? or UCASE(SectionName) like ?';
            this.StaffList = alasql(queryString, [this.ClonedStaffList, searchKeyword, searchKeyword, searchKeyword]);
            this.HasFilter = true;
        }
        else {
            this.StaffList = alasql(queryString, [this.ClonedStaffList]);
        }
        
        if (typeof this.FilterModel.SkillId == "string")
            this.FilterModel.SkillId = parseInt(this.FilterModel.SkillId);

        if (this.FilterModel.SkillId != 0) {
            this.StaffList = this.StaffList.filter((item) => {
                if (item.Skills.indexOf(this.FilterModel.SkillId)>=0)
                    return item;
            });
            this.HasFilter = true;
        }

        if (+this.FilterModel.SectionId != 0) {
            this.StaffList = this.StaffList.filter((item) => item.Sections.indexOf(this.FilterModel.SectionId) >= 0);
            this.HasFilter = true;
        }
        if (this.FilterModel.StaffId && this.FilterModel.StaffId != 0) {
            this.StaffList = this.StaffList.filter((item) => {
                if (item.StaffId == this.FilterModel.StaffId) {
                    this.StaffName = item.Description;
                    return true
                }
            })
            this.HasFilter = true;
        }
        if (this.FilterModel.OnlySelectedStaff) {
            this.StaffList = alasql('Select * From ? where Selected == true', [this.StaffList]);
            this.HasFilter = true;
        }

        let SelectedStaffCount: number = 0;
        this.StaffList.forEach(row => {
            if (row.Selected == true) {                
                SelectedStaffCount++;
            }
        })
        if (SelectedStaffCount && SelectedStaffCount == this.StaffList.length)
            this.AllStaffSelected = true;
        else
            this.AllStaffSelected = false;
            this.StaffList.forEach(staff => {
               staff.Skills = this.checkSkillWithCategory(staff.Skills);
               staff.SkillName =this.shiftSetUp.GetSkillName(staff.Skills);
            })
    }


    SetStaffId(staffId): void {
        this.StaffId = parseInt(staffId);
    }

    SectionUpdate(sectionList): void {
        
        let index = this.MappedStaff.findIndex(obj => obj.StaffId == this.StaffId);
        let pointer_ = this.ClonedStaffList.findIndex(obj => obj.StaffId == this.StaffId);
        this.ClonedStaffList[pointer_].Sections = _.cloneDeep(sectionList);
        this.ClonedStaffList[pointer_].SectionName = this.shiftSetUp.GetSectionName(sectionList);
        if (index >= 0) {
            this.MappedStaff[index].Sections = _.cloneDeep(sectionList);
        }
        else {
            this.MappedStaff.push(this.ClonedStaffList[pointer_]);
        }
        this.LoadFilterStaffData();
    }

    SkillUpdate(SkillList): void {
        let index = this.MappedStaff.findIndex(obj => obj.StaffId == this.StaffId);
        let pointer_ = this.ClonedStaffList.findIndex(obj => obj.StaffId == this.StaffId);
        this.ClonedStaffList[pointer_].Skills = _.cloneDeep(SkillList);
        this.ClonedStaffList[pointer_].SkillName = this.shiftSetUp.GetSkillName(SkillList);    
        if (index >= 0) {
            this.MappedStaff[index].Skills = _.cloneDeep(SkillList);
        }
        else {
            this.MappedStaff.push(this.ClonedStaffList[pointer_]);
        }
        this.LoadFilterStaffData();
    }

    MapStaff(StaffDetail, event): void {
        
        let index = this.MappedStaff.findIndex(obj => obj.StaffId == StaffDetail.StaffId);
        if (event.target.checked) {
            this.ClonedStaffList.find(Staff => Staff.StaffId == StaffDetail.StaffId).Selected = true;
            if (index >= 0) {
                if (this.MappedStaff[index].Sections.indexOf(this.Model.SectionId) < 0) {
                    this.MappedStaff[index].Sections.push(this.Model.SectionId);
                }
                this.MappedStaff[index].Skills = _.cloneDeep(StaffDetail.Skills);
            }
            else {
                StaffDetail.Sections.push(this.Model.SectionId);

                this.MappedStaff.push(StaffDetail);
            }
            
        }
        else {
            if (index >= 0) {
                this.MappedStaff.splice(index, 1);
            }
            this.ClonedStaffList.find(Staff => Staff.StaffId == StaffDetail.StaffId).Selected = false;
            StaffDetail.Sections = [];
            StaffDetail.Sections.push(this.Model.SectionId);
            this.RemovedStaffList.push(StaffDetail);

        }       
        this.LoadFilterStaffData();
    }

    SaveMapping(): void {
 

        if (this.RemovedStaffList.length > 0) {
            this.RemovedStaffList.forEach(removedStaff => {
                let index_ = this.SaveShiftResponse.SectionStaffMapping.findIndex(obj => obj.StaffId == removedStaff.StaffId && obj.SectionId == this.Model.SectionId);
                let pointer_ = this.SaveShiftResponse.ListStaffSkills.findIndex(obj => obj.StaffId == removedStaff.StaffId);
                let i = this.AllStaffList.findIndex(obj => obj.StaffId == removedStaff.StaffId);
                let k = this.ClonedStaffList.findIndex(obj => obj.StaffId == removedStaff.StaffId);
                this.AllStaffList[i].Skills = this.ClonedStaffList[k].Skills;
                this.AllStaffList[i].SkillName = this.shiftSetUp.GetSkillName(this.AllStaffList[i].Skills);
                let sectionIndex = this.AllStaffList[i].Sections.findIndex(obj => obj == removedStaff.Sections[0]);
                this.AllStaffList[i].Sections.splice(sectionIndex, 1);
                this.AllStaffList[i].SectionName = this.shiftSetUp.GetSectionName(this.AllStaffList[i].Sections);
                if (index_ >= 0) {
                    this.SaveShiftResponse.SectionStaffMapping.splice(index_, 1);
                }
                if (pointer_ >= 0) {
                    this.SaveShiftResponse.ListStaffSkills[pointer_].Skills = _.cloneDeep(this.ClonedStaffList[k].Skills); 
                }

                let SectionObj = this.shiftSetUp.SectionSkillStaffData.find(obj => obj.Id == this.Model.SectionId);
                SectionObj.Skills.forEach(SkillObj => {
                        let pointer = SkillObj.Staff.findIndex(obj => obj.StaffId == removedStaff.StaffId);
                        if (pointer >= 0) {
                            SkillObj.Staff.splice(pointer, 1);
                        }
                })
            })
            
        }
        this.MappedStaff.forEach(StaffItem => {
            let Staff_SkillObj: any = {};           
            let index = this.SaveShiftResponse.ListStaffSkills.findIndex(obj => obj.StaffId == StaffItem.StaffId);
            if (index >= 0) {
                this.SaveShiftResponse.ListStaffSkills[index].Skills = _.cloneDeep(StaffItem.Skills);
               // this.SaveShiftResponse.ListStaffSkills[index].Skills = _.concat(this.SaveShiftResponse.ListStaffSkills[index].Skills, StaffItem.Skills);
            }
            else {
                Staff_SkillObj.StaffId = StaffItem.StaffId;
                Staff_SkillObj.Skills = _.cloneDeep(StaffItem.Skills);
                this.SaveShiftResponse.ListStaffSkills.push(Staff_SkillObj);
            }
            this.SaveShiftResponse.SectionStaffMapping = this.SaveShiftResponse.SectionStaffMapping.filter(a => a.StaffId != StaffItem.StaffId);
            StaffItem.Sections.forEach(sectionId => {
                let Section_StaffObj: any = {};
                let index_ = this.SaveShiftResponse.SectionStaffMapping.findIndex(obj => obj.StaffId == StaffItem.StaffId && obj.SectionId == sectionId);
                if (index_ < 0) {
                    Section_StaffObj.StaffId = StaffItem.StaffId;
                    Section_StaffObj.SectionId = sectionId;
                    this.SaveShiftResponse.SectionStaffMapping.push(Section_StaffObj);
                }
            })
            let i = this.AllStaffList.findIndex(obj => obj.StaffId == StaffItem.StaffId);
            let k = this.ClonedStaffList.findIndex(obj => obj.StaffId == StaffItem.StaffId);
            this.AllStaffList[i].Skills = this.ClonedStaffList[k].Skills;
            this.AllStaffList[i].SkillName = this.shiftSetUp.GetSkillName(this.AllStaffList[i].Skills);
            this.AllStaffList[i].Sections = _.cloneDeep(StaffItem.Sections);
            this.AllStaffList[i].SectionName = this.shiftSetUp.GetSectionName(this.AllStaffList[i].Sections);
        });

        this.shiftSetUp.SectionSkillStaffData.forEach(Section => {
            Section.Skills.forEach(Skill => {

                /**************************Unskilled Staff**********************/

                if (Skill.Id == -1) {             
                    this.RemovedStaffList.forEach(StaffObj => {
                        let i = Skill.Staff.findIndex(obj => obj.StaffId == StaffObj.StaffId);
                        if (i >= 0) {
                            if (StaffObj.Sections[0] == Section.Id || StaffObj.Skills.length > 0)
                                Skill.Staff.splice(i, 1);
                            else {
                                let StaffSectionMap = [];
                                StaffSectionMap = this.SaveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == StaffObj.StaffId);
                                if (StaffSectionMap.length > 1) {
                                    StaffObj.MultipleSections = true;
                                }
                                else
                                    StaffObj.MultipleSections = false;
                                Skill.Staff[i] = (StaffObj);
                            }
                        }
                        else {
                            let k = this.SaveShiftResponse.SectionStaffMapping.findIndex(obj => obj.StaffId == StaffObj.StaffId && obj.SectionId == Section.Id);
                            if (k >= 0) {
                                if (StaffObj.Skills.length == 0) {
                                    let StaffSectionMap = [];
                                    StaffSectionMap = this.SaveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == StaffObj.StaffId);
                                    if (StaffSectionMap.length > 1) {
                                        StaffObj.MultipleSections = true;
                                    }
                                    else
                                        StaffObj.MultipleSections = false;
                                    Skill.Staff.push(StaffObj);
                                }
                            }
                        }

                        
                    })
                    this.MappedStaff.forEach(StaffItem => {
                        let i = Skill.Staff.findIndex(obj => obj.StaffId == StaffItem.StaffId);
                        if (i >= 0) {
                            if (StaffItem.Skills.length > 0) {
                                Skill.Staff.splice(i, 1);
                            }
                            else {
                                let StaffSectionMap = [];
                                StaffSectionMap = this.SaveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == StaffItem.StaffId);
                                if (StaffSectionMap.length > 1) {
                                    Skill.Staff[i].MultipleSections = true;
                                }
                                else
                                    Skill.Staff[i].MultipleSections = false;
                            }
                        }
                        else {
                            if (StaffItem.Sections.indexOf(Section.Id)>=0 && StaffItem.Skills.length == 0) {
                                let StaffSectionMap = [];
                                StaffSectionMap = this.SaveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == StaffItem.StaffId);
                                if (StaffSectionMap.length > 1) {
                                    StaffItem.MultipleSections = true;
                                }
                                else
                                    StaffItem.MultipleSections = false;
                                Skill.Staff.push(StaffItem);
                            }
                        }
                    })
                }
                else {
                    this.RemovedStaffList.forEach(StaffObj => {
                        let i = Skill.Staff.findIndex(obj => obj.StaffId == StaffObj.StaffId);
                        if (i >= 0) {
                            if (!(StaffObj.Skills.indexOf(Skill.Id)>=0)) {
                                Skill.Staff.splice(i, 1);
                            }
                            else {
                                let StaffSectionMap = [];
                                StaffSectionMap = this.SaveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == StaffObj.StaffId);
                                if (StaffSectionMap.length > 1) {
                                    Skill.Staff[i].MultipleSections = true;
                                }
                                else
                                    Skill.Staff[i].MultipleSections = false;
                            }

                        }
                    });
                    this.MappedStaff.forEach(StaffItem => {
                        let i = Skill.Staff.findIndex(obj => obj.StaffId == StaffItem.StaffId);
                        if (i >= 0) {
                            if (StaffItem.Sections.findIndex(element => element == Section.Id) < 0) {
                                Skill.Staff.splice(i, 1);
                            }
                            else if (StaffItem.Skills.findIndex(element => element == Skill.Id) < 0) {
                                Skill.Staff.splice(i, 1);
                            }
                            else {
                                let StaffSectionMap = [];
                                StaffSectionMap = this.SaveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == StaffItem.StaffId);
                                if (StaffSectionMap.length > 1) {
                                    Skill.Staff[i].MultipleSections = true;
                                }
                                else
                                    Skill.Staff[i].MultipleSections = false;
                            }

                            //Skill.Staff.push(StaffItem);
                        }
                        else if (StaffItem.Sections.indexOf(Section.Id) >= 0 && StaffItem.Skills.indexOf(Skill.Id) >= 0 && i < 0) {
                            let StaffSectionMap = [];
                            StaffSectionMap = this.SaveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == StaffItem.StaffId);
                            if (StaffSectionMap.length > 1) {
                                StaffItem.MultipleSections = true;
                            }
                            else
                                StaffItem.MultipleSections = false;
                            Skill.Staff.push(StaffItem);
                        }
                    });
                }                

            })
        });
        this.FilterModel.Keyword = '';
        this.ModalRef.close();

    }

    SelectAllStaff(event): void {
        this.RemovedStaffList = [];
        this.MappedStaff = [];
        if (event.target.checked) {
            if (this.StaffList) {
                this.StaffList.forEach(Staff => {
                    if (!(Staff.Sections.indexOf(this.Model.SectionId)>=0)) {
                        Staff.Sections.push(this.Model.SectionId);
                    }
                    this.MappedStaff.push(Staff);
                    Staff.Selected = true;
                    this.ClonedStaffList.find(obj => obj.StaffId == Staff.StaffId).Selected = true;
                })
            }
        }
        else {
            if (this.StaffList) {
                this.StaffList.forEach(Staff => {
                    this.RemovedStaffList.push(Staff);
                    Staff.Selected = false;
                    this.ClonedStaffList.find(obj => obj.StaffId == Staff.StaffId).Selected = false;
                })
            }

        }
        this.LoadFilterStaffData();
    }

    UpdateStaffData(StaffLst: any): void {
        StaffLst.forEach(StaffDetails => {
            let index = this.AllStaffList.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
            if (index >= 0) {
                this.AllStaffList[index].IsLoggedIn = StaffDetails.LoginStatus;
                this.AllStaffList[index].AllOpenCalls = StaffDetails.AllOpenCalls || 0;
                this.AllStaffList[index].OpenCalls = StaffDetails.OpenCalls || 0;
            }
           
            let index_ = this.StaffList.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
            if (index_ >= 0) {
                this.StaffList[index_].IsLoggedIn = StaffDetails.LoginStatus;
                this.StaffList[index_].AllOpenCalls = StaffDetails.AllOpenCalls || 0;
                this.StaffList[index_].OpenCalls = StaffDetails.OpenCalls || 0;
            }

            let pointer = this.ClonedStaffList.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
            if (pointer >= 0) {
                this.ClonedStaffList[pointer].IsLoggedIn = StaffDetails.LoginStatus;
                this.ClonedStaffList[pointer].AllOpenCalls = StaffDetails.AllOpenCalls;
                this.ClonedStaffList[pointer].OpenCalls = StaffDetails.OpenCalls;
            }

            this.shiftSetUp.SectionSkillStaffData.forEach(Section => {
                Section.Skills.forEach(Skill => {
                    let index = Skill.Staff.findIndex(obj => obj.StaffId == StaffDetails.StaffId);
                    if (index >= 0) {
                        Skill.Staff[index].IsLoggedIn = StaffDetails.LoginStatus;
                    }
                })
            });  
        })
  
    }

    UpdateDeviceData(staffId: number): void {
        this.shiftSetUp.SectionSkillStaffData.forEach(Section => {
            Section.Skills.forEach(Skill => {
                let index = Skill.Staff.findIndex(obj => obj.StaffId == staffId);
                
                    if (this.shiftSetUp.ShiftResponseModel.ListStaffDevices.findIndex(item => item.StaffId == staffId) >= 0) {
                        this.AllStaffList.find(obj => obj.StaffId == staffId).HasDevices = true;
                        this.StaffList.find(obj => obj.StaffId == staffId).HasDevices = true;
                        this.ClonedStaffList.find(obj => obj.StaffId == staffId).HasDevices = true;
                        if (index >= 0) Skill.Staff[index].HasDevices = true;
                    }
                    else {
                        this.AllStaffList.find(obj => obj.StaffId == staffId).HasDevices = false;
                        this.StaffList.find(obj => obj.StaffId == staffId).HasDevices = false;
                        this.ClonedStaffList.find(obj => obj.StaffId == staffId).HasDevices = false;
                        if(index >= 0) Skill.Staff[index].HasDevices = false;
                    }
                
            })
        });
        
    }

    onClearFilter() {
        this.FilterModel.ClearFilters();
        if (this.Model.SkillId) 
            this.FilterModel.SkillId = this.Model.SkillId;      

        this.LoadFilterStaffData();
    }
}
